<template>
  <li
    ref="serviceElement"
    class="flex gap-x-2 py-4"
    :class="{ 'bg-gray-lighten3': isActive }"
    @click="$emit('click')"
  >
    <UiIcon icon="location" class="shrink-0" />
    <div>
      <h3 class="title text-sm uppercase text-blue">
        {{ name }}
      </h3>
      <div class="mt-2">
        <p class="text-sm text-blue">
          <a :href="`https://${url}`" target="_blank" class="break-all">
            {{ url }}
          </a>
        </p>
        <p class="text-sm">
          {{ address }}
        </p>
        <p v-for="(phone, j) in phones" :key="j" class="text-sm text-blue">
          <a :href="`tel:${phone}`">{{ phone }}</a>
        </p>
        <p v-if="workingHours && workingHours.length" class="text-sm">
          {{ $t('working_hours') }}
          <span v-for="(time, j) in workingHours" :key="j">
            {{ formatTime(time, j) }}
          </span>
        </p>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

interface Props {
  name?: string | null;
  url?: string | null;
  address?: string | null;
  phones?: any[];
  workingHours?: any[];
  isActive?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  name: null,
  url: null,
  address: null,
  phones: () => [],
  workingHours: () => [],
  isActive: false,
});

defineEmits<{
  (e: 'click'): void;
}>();

const serviceElement = ref();
const formatTime = (time: any, index: number) => {
  return `${index > 0 ? '-' : ''} ${time.start}-${time.end}`;
};

watch(
  () => props.isActive,
  (value) => {
    if (!value) return;
    serviceElement.value.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  },
);
</script>
